import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings (commonly emitted by third-party
// embedded widgets such as Elfsight). These do not affect runtime behaviour but
// trigger CRA's dev error overlay.
const RESIZE_OBSERVER_ERR_MSG =
  "ResizeObserver loop completed with undelivered notifications.";
const RESIZE_OBSERVER_ERR_MSG_LEGACY =
  "ResizeObserver loop limit exceeded";
window.addEventListener("error", (e) => {
  if (
    e.message === RESIZE_OBSERVER_ERR_MSG ||
    e.message === RESIZE_OBSERVER_ERR_MSG_LEGACY
  ) {
    e.stopImmediatePropagation();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
